import { useEffect, useState } from "react";

const COARSE_POINTER = "(pointer: coarse)";

// `(pointer: coarse)` is the signal for a device that raises an on-screen
// keyboard — viewport width alone cannot tell us that. Resolved on the first
// render so mount-time decisions such as autofocus see the real value.
export default function useTouchDevice() {
  const [isTouch, setIsTouch] = useState(
    () =>
      typeof window !== "undefined" && window.matchMedia(COARSE_POINTER).matches
  );

  useEffect(() => {
    const query = window.matchMedia(COARSE_POINTER);
    const handleChange = (event) => setIsTouch(event.matches);

    setIsTouch(query.matches);
    query.addEventListener("change", handleChange);

    return () => query.removeEventListener("change", handleChange);
  }, []);

  return isTouch;
}
